import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { WatchlistMovie } from '../Watchlist';

interface EditWatchlistModalProps {
  show: boolean;
  onHide: () => void;
  movie: WatchlistMovie;
  onEditMovie: (id: string, updates: Partial<WatchlistMovie>) => void;
}

const EditWatchlistModal = ({
  show,
  onHide,
  movie,
  onEditMovie,
}: EditWatchlistModalProps) => {
  const [watchCount, setWatchCount] = useState(movie.watchCount);

  useEffect(() => {
    if (show) {
      setWatchCount(movie.watchCount);
    }
  }, [show, movie]);

  const handleSave = () => {
    onEditMovie(movie.id, { watchCount });
    onHide();
  };

  return (
    <Dialog open={show} onClose={onHide} maxWidth="xs" fullWidth>
      <DialogTitle>Edit &quot;{movie.title}&quot;</DialogTitle>

      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <TextField
            label="Watch Count"
            type="number"
            value={watchCount}
            onChange={(e) =>
              setWatchCount(Math.max(0, parseInt(e.target.value, 10) || 0))
            }
            inputProps={{ min: 0 }}
            fullWidth
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onHide}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditWatchlistModal;